import React from 'react'

function ForgotPassword() {
  return (
    <div>
      <h3>ForgotPassword</h3>
    </div>
  )
}

export default ForgotPassword
